import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import {
  getCompanies,
  getHourRegistrationForInvoicesOfCompany,
} from "../actions/companyActions";

import Form from "./forms/Form";
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from "@material-ui/core";

import FullScreenLoader from "../components/FullScreenLoader";

import { KeyboardDatePicker } from "@material-ui/pickers";

import TimeStringHelper from "../helpers/TimeStringHelper";

import exportTableToExcel from "../helpers/export-table-to-excel";
import { getCollectiveLabourAgreements } from "../actions/claActions";
import calculateAllowanceForShift from "../helpers/calculateAllowanceForShift";
import mergeNumericObjects from "../helpers/mergeNumericObjects";
import formatPrice from "../utils/format-price";
import moment from "moment";
import { GetApp } from "@material-ui/icons";

const HourRegistrationForInvoices = (props) => {
  const [isFetching, setIsFetching] = useState(false);

  const [beginDate, setBeginDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [company, setCompany] = useState("");

  const [clas, setClas] = useState([]);
  const [optionCompanies, setOptionCompanies] = useState([]);
  const [hourRegistration, setHourRegistration] = useState([]);

  useEffect(() => refreshData(), []);

  useEffect(() => {
    refreshCompanies();
  }, [beginDate, endDate]);

  const refreshCompanies = async () => {
    try {
      setIsFetching(true);

      const params = {
        ...(beginDate && {
          hasScheduledShiftAfter: beginDate,
        }),
        ...(endDate && {
          hasScheduledShiftBefore: endDate,
        }),
      };

      const companies = await props.getCompanies(params);
      setOptionCompanies(companies);
    } catch (error) {
      console.error(error);
    } finally {
      setIsFetching(false);
    }
  };

  const refreshData = async () => {
    try {
      setIsFetching(true);

      const params = {
        ...(beginDate && {
          hasScheduledShiftAfter: beginDate,
        }),
        ...(endDate && {
          hasScheduledShiftBefore: endDate,
        }),
      };

      const [clas, companies] = await Promise.all([
        getCollectiveLabourAgreements(),
        props.getCompanies(params),
      ]);

      setClas(clas);
      setOptionCompanies(companies);
    } catch (error) {
      console.error(error);
    } finally {
      setIsFetching(false);
    }
  };

  const searchHourRegistration = async () => {
    try {
      setIsFetching(true);
      setHourRegistration([]);

      const hourRegistration = await getHourRegistrationForInvoicesOfCompany(
        company,
        beginDate,
        endDate,
      );

      setHourRegistration(hourRegistration);
    } finally {
      setIsFetching(false);
    }
  };

  let totalNumberOfShifts = 0,
    totalBreakTimeSubstraction = 0,
    totalNumberOfMinutes = 0,
    totalPrice = 0.0,
    totalAllowance = 0.0,
    totalAllowances = {},
    totalDistance = 0;

  return (
    <Fragment>
      <Form>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KeyboardDatePicker
              clearable
              mask="__-__-____"
              id="beginDate"
              name="beginDate"
              label="Begindatum *"
              value={beginDate}
              format={"L"}
              onChange={(m) => setBeginDate(m)}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KeyboardDatePicker
              clearable
              mask="__-__-____"
              id="endDate"
              name="endDate"
              label="Einddatum *"
              value={endDate}
              format={"L"}
              onChange={(m) => setEndDate(m)}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <Fragment>
              <InputLabel htmlFor="company">Bedrijf *</InputLabel>
              <Select
                id="company"
                name="company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                fullWidth
              >
                {optionCompanies.map((c) => (
                  <MenuItem
                    key={c.email}
                    value={c.email}
                    style={{
                      fontWeight: company != c.email ? "normal" : "500",
                    }}
                  >
                    {c.name}
                  </MenuItem>
                ))}
              </Select>
            </Fragment>
          </Grid>

          <Grid item xs={12} sm={12} onClick={searchHourRegistration}>
            <Button variant="contained" color="primary">
              Zoek
            </Button>
          </Grid>
        </Grid>
      </Form>

      <div style={{ overflowX: "auto" }}>
        <Table id="hour-registration-for-invoices-table">
          <TableHead>
            <TableRow>
              <TableCell>Datum</TableCell>
              <TableCell>Medewerker</TableCell>
              <TableCell>Aanvang</TableCell>
              <TableCell>Einde</TableCell>
              <TableCell>Pauze</TableCell>
              <TableCell>Uren</TableCell>
              <TableCell>Uurtarief (excl. BTW)</TableCell>
              <TableCell>Prijs (excl. BTW)</TableCell>
              <TableCell>Toeslag</TableCell>
              <TableCell>Km</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {hourRegistration.map((project, i) => {
              let subTotalNumberOfShifts = 0,
                subTotalBreakTimeSubstraction = 0,
                subTotalNumberOfMinutes = 0,
                subTotalPrice = 0.0,
                subTotalAllowance = 0.0,
                subTotalAllowances = {},
                subTotalDistance = 0;

              if (!project.shifts.some((s) => s.employees.length)) return;

              return (
                <Fragment key={i}>
                  <TableRow key={`project_${i}`}>
                    <TableCell colSpan={9}>
                      <b>{project.name}</b>
                    </TableCell>
                  </TableRow>

                  {project.shifts.map((shift) => {
                    const { priceForRequesting } = shift;

                    return shift.employees.map((employee, i) => {
                      let startDateTime =
                          employee.CompanyEmployeeShift.startDateTime ||
                          shift.beginDatetime,
                        endDateTime =
                          employee.CompanyEmployeeShift.endDateTime ||
                          shift.endDatetime,
                        breakTimeSubstraction =
                          typeof employee.CompanyEmployeeShift
                            .breakTimeSubstraction === "number"
                            ? employee.CompanyEmployeeShift
                                .breakTimeSubstraction
                            : shift.breakTimeSubstraction,
                        workedMinutes = parseInt(
                          Math.abs(
                            moment(endDateTime).diff(moment(startDateTime)),
                          ) /
                            (60 * 1000) -
                            breakTimeSubstraction,
                        );

                      let price =
                        parseFloat(priceForRequesting) * (workedMinutes / 60);

                      const cla =
                        clas.find((cla) => cla.id === shift.claId) || {};
                      const { allowance = 0, ...allowancePercentages } =
                        calculateAllowanceForShift(
                          {
                            startDateTime,
                            endDateTime,
                            price: priceForRequesting,
                          },
                          {
                            allowances: cla.allowances,
                            timezone: "Europe/Amsterdam",
                          },
                        );

                      subTotalAllowances = mergeNumericObjects(
                        allowancePercentages,
                        subTotalAllowances,
                      );
                      totalAllowances = mergeNumericObjects(
                        allowancePercentages,
                        totalAllowances,
                      );

                      subTotalNumberOfShifts++;
                      subTotalBreakTimeSubstraction += breakTimeSubstraction;
                      subTotalNumberOfMinutes += workedMinutes;
                      subTotalPrice += price;
                      subTotalAllowance += allowance;
                      subTotalDistance += parseInt(
                        employee.CompanyEmployeeShift.distance,
                      );

                      totalNumberOfShifts++;
                      totalBreakTimeSubstraction += breakTimeSubstraction;
                      totalNumberOfMinutes += workedMinutes;
                      totalPrice += price;
                      totalAllowance += allowance;
                      totalDistance += parseInt(
                        employee.CompanyEmployeeShift.distance,
                      );

                      return (
                        <TableRow key={`shift_${shift.id}_${i}`}>
                          <TableCell>
                            {moment(
                              employee.CompanyEmployeeShift.startDateTime ||
                                shift.beginDatetime,
                            )
                              .locale("nl-NL")
                              .format("ddd, D MMMM YYYY")}
                          </TableCell>
                          <TableCell>
                            {employee.employee.firstName}{" "}
                            {employee.employee.lastName}
                          </TableCell>
                          <TableCell>
                            {moment(startDateTime).format("LT")}
                          </TableCell>
                          <TableCell>
                            {moment(endDateTime).format("LT")}
                          </TableCell>
                          <TableCell>
                            {breakTimeSubstraction > 0
                              ? `${breakTimeSubstraction} min`
                              : "-"}
                          </TableCell>
                          <TableCell>
                            {TimeStringHelper.parseMinutesToString(
                              workedMinutes,
                            )}
                          </TableCell>
                          <TableCell>
                            {formatPrice(shift.priceForRequesting)}
                          </TableCell>
                          <TableCell>{formatPrice(price)}</TableCell>
                          <TableCell>
                            {Object.keys(allowancePercentages)
                              .map((percentage) => {
                                const minutes =
                                  allowancePercentages[percentage];
                                const time =
                                  TimeStringHelper.parseMinutesToString(
                                    minutes,
                                  );
                                return `${time} x ${percentage}%`;
                              })
                              .join(" en ")}
                          </TableCell>
                          <TableCell>
                            {parseInt(employee.CompanyEmployeeShift.distance)}{" "}
                            km
                          </TableCell>
                        </TableRow>
                      );
                    });
                  })}

                  <TableRow key={`subtotals_${i}`}>
                    <TableCell colSpan={2}>
                      <b>Subtotalen</b>
                    </TableCell>
                    <TableCell colSpan={2}>
                      <b>
                        {subTotalNumberOfShifts} dienst
                        {subTotalNumberOfShifts > 1 ? "en" : null}
                      </b>
                    </TableCell>
                    <TableCell>
                      <b>
                        {subTotalBreakTimeSubstraction > 0
                          ? `${subTotalBreakTimeSubstraction} min`
                          : "-"}
                      </b>
                    </TableCell>
                    <TableCell>
                      <b>
                        {TimeStringHelper.parseMinutesToString(
                          subTotalNumberOfMinutes,
                        )}
                      </b>
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      <b>{formatPrice(subTotalPrice)}</b>
                    </TableCell>
                    <TableCell>
                      <b>{formatPrice(subTotalAllowance)}</b>
                    </TableCell>
                    <TableCell>
                      <b>
                        {parseFloat(subTotalDistance).toLocaleString("nl-NL")}{" "}
                        km
                      </b>
                    </TableCell>
                  </TableRow>

                  {Object.keys(subTotalAllowances).map((subTotalAllowance) => (
                    <TableRow
                      key={`subtotals_allowance_${subTotalAllowance}_${i}`}
                    >
                      <TableCell colSpan={2}> </TableCell>
                      <TableCell colSpan={2}>
                        Toeslag {subTotalAllowance}%
                      </TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>
                        {TimeStringHelper.parseMinutesToString(
                          subTotalAllowances[subTotalAllowance],
                        )}
                      </TableCell>
                      <TableCell colSpan={4}></TableCell>
                    </TableRow>
                  ))}

                  <TableRow key={`empty_row_${i}`}>
                    <TableCell colSpan={10}></TableCell>
                  </TableRow>
                </Fragment>
              );
            })}

            <TableRow key={`totals`}>
              <TableCell colSpan={2}>
                <b>Totalen</b>
              </TableCell>
              <TableCell colSpan={2}>
                <b>
                  {totalNumberOfShifts} dienst
                  {totalNumberOfShifts > 1 ? "en" : null}
                </b>
              </TableCell>
              <TableCell>
                <b>
                  {totalBreakTimeSubstraction > 0
                    ? `${totalBreakTimeSubstraction} min`
                    : "-"}
                </b>
              </TableCell>
              <TableCell>
                <b>
                  {TimeStringHelper.parseMinutesToString(totalNumberOfMinutes)}
                </b>
              </TableCell>
              <TableCell>
                <b>Totaal excl. BTW</b>
              </TableCell>
              <TableCell>
                <b>{formatPrice(totalPrice)}</b>
              </TableCell>
              <TableCell> </TableCell>
              <TableCell>
                <b>{totalDistance} km</b>
              </TableCell>
            </TableRow>

            {Object.keys(totalAllowances).map((totalAllowance) => (
              <TableRow key={`totals_allowance_${totalAllowance}`}>
                <TableCell colSpan={2}> </TableCell>
                <TableCell colSpan={2}>Toeslag {totalAllowance}%</TableCell>
                <TableCell>-</TableCell>
                <TableCell>
                  {TimeStringHelper.parseMinutesToString(
                    totalAllowances[totalAllowance],
                  )}
                </TableCell>
                <TableCell colSpan={4}></TableCell>
              </TableRow>
            ))}

            <TableRow key={`allowance`}>
              <TableCell colSpan={2}></TableCell>
              <TableCell colSpan={2}></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>
                <b>Totaal toeslag</b>
              </TableCell>
              <TableCell>
                <b>{formatPrice(totalAllowance)}</b>
              </TableCell>
              <TableCell></TableCell>
            </TableRow>

            <TableRow key={`tax`}>
              <TableCell colSpan={2}></TableCell>
              <TableCell colSpan={2}></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>
                <b>BTW (21%)</b>
              </TableCell>
              <TableCell>
                <b>{formatPrice((totalPrice + totalAllowance) * 0.21)}</b>
              </TableCell>
              <TableCell></TableCell>
            </TableRow>

            <TableRow key={`total_incl_tax`}>
              <TableCell colSpan={2}></TableCell>
              <TableCell colSpan={2}></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>
                <b>Totaal incl. BTW</b>
              </TableCell>
              <TableCell>
                <b>{formatPrice((totalPrice + totalAllowance) * 1.21)}</b>
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>

      {isFetching && <FullScreenLoader />}

      <br />

      <Button
        variant="outlined"
        color="primary"
        startIcon={<GetApp />}
        onClick={() =>
          exportTableToExcel("hour-registration-for-invoices-table")
        }
      >
        Exporteer naar Excel
      </Button>
    </Fragment>
  );
};

HourRegistrationForInvoices.propTypes = {
  getCompanies: PropTypes.func.isRequired,
};

export default connect(null, {
  getCompanies,
})(HourRegistrationForInvoices);



// WEBPACK FOOTER //
// ./src/components/HourRegistrationForInvoices.js